import Portfolio6 from './Portfolio6'
export default Portfolio6
